import React, { Component } from "react"
import _ from "lodash"
import { connect } from "react-redux"

export default function RequireSelectedLitterMember(ComposedComponent) {
  class Authentication extends Component {
    UNSAFE_componentWillMount() {
      if (_.isEmpty(this.props.selectedLitterMember)) {
        this.props.history.push("/userhome/dashboard/litter")
      }
    }

    UNSAFE_componentWillUpdate(nextProps) {
      if (_.isEmpty(nextProps.selectedLitterMember)) {
        this.props.history.push("/userhome/dashboard/litter")
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  const mapStateToProps = (state) => {
    return {
      selectedLitterMember: state.reducers.litters.selectedLitterMember,
    }
  }
  return connect(mapStateToProps)(Authentication)
}
